module.exports = __webpack_public_path__ + "media/flags/yt-16c24fa7.svg";